import { render, staticRenderFns } from "./AppExpansionPanelHeader.vue?vue&type=template&id=a6dbd612&scoped=true&"
import script from "./AppExpansionPanelHeader.vue?vue&type=script&lang=ts&"
export * from "./AppExpansionPanelHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AppExpansionPanelHeader.vue?vue&type=style&index=0&id=a6dbd612&lang=scss&scoped=true&"
import style1 from "./AppExpansionPanelHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6dbd612",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
installComponents(component, {VExpansionPanelHeader})
